import { useAlerts } from '@/composables/alerts';

export const useOrderNotifications = () => {
  const { warn, error } = useAlerts();
  const notify = (count = 0) => {
    warn('تم استلام طلب جديد', `يوجد  ${count} طلب في الإنتظار`);

    // play a notification sound
    const audio = new Audio('/sounds/alarm.mp3');
    audio.play().catch(error => {
      console.error('Error playing notification sound:', error);
    });
    // Optionally, you can also use the Notification API to show a browser notification
    if (Notification.permission === 'granted') {
      new Notification('طلب جديد', {
        body: `يوجد ${count} طلب في الإنتظار`,
      });
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          new Notification('طلب جديد', {
            body: `يوجد ${count} طلب في الإنتظار`,
          });
        }
      });
    }
  };

  const notifyAlarm = (count = 0) => {
    error('طلبات متأخره', `يوجد ${count} طلب في الإنتظار`);

    // play a notification sound
    const audio = new Audio('/sounds/error.mp3');
    audio.play().catch(error => {
      console.error('Error playing error sound:', error);
    });

    // Optionally, you can also use the Notification API to show a browser notification
    if (Notification.permission === 'granted') {
      new Notification('طلبات متأخره', {
        body: `يوجد ${count} طلب في الإنتظار`,
      });
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          new Notification('طلبات متأخره', {
            body: `يوجد ${count} طلب في الإنتظار`,
          });
        }
      });
    }
  };

  return {
    notify,
    notifyAlarm,
  };
};
